<template>
  <ul>
    <li
      v-for="(item, index) in processedEvents"
      :key="index"
      class="flex items-center"
      :class="{ 'pb-2 mb-2 border-b border-solid border-black': index + 1 !== processedEvents.length || showMoreEventDates, 'opacity-40': item.isExpired }"
    >
      <time v-if="item.eventDate" :datetime="new Date(item.eventDate).toISOString()" class="flex align-right w-[150px] justify-between mr-2 shrink-0">
        <span class="font-semibold text-left">{{ $d(new Date(item.eventDate), 'long-date') }}</span>
        <span class="content-center text-right">{{ $d(new Date(item.eventDate), 'short-time') }}</span>
      </time>

      <div v-if="!item.isExpired && item.statusLabel" class="flex">
        <span class="text-app-primary-1-red--torch">{{ $t(item.statusLabel) }}</span>
      </div>
      <div class="flex ml-auto">
        <MoleculeButton
          :url="item.url"
          text-color="text-black"
          :shadowed="false"
          size="medium"
          class="max-h-8 !px-0 sm:!px-0 bg-transparent hover:bg-transparent"
          @click="onSeeConcertClick"
        >
          {{ $t('event-view-concert') }}
        </MoleculeButton>
      </div>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { dateInPast } from '@/assets/date'

const props = defineProps({
  additionalEvents: { type: Array as PropType<any[]>, required: false, default: () => [] },
  showMoreEventDates: { type: Boolean, required: false, default: false },
})

const gtmCdpAction = setupGtmCdpAction()
const tixSaleStatuses: Record<number, string> = {
  1: 'event-detail-few-tickets-button-label',
  2: 'event-detail-sold-out-button-label',
}

function setStatusLabel(iConcertStatus?: string, tixStatus?: number) {
  if (tixStatus) {
    return tixSaleStatuses[tixStatus]
  }

  if (iConcertStatus === 'Verplaatst') {
    return 'event-detail-moved-button-label'
  }

  if (iConcertStatus === 'Geannuleerd') {
    return 'event-detail-canceled-button-label'
  }
}

function onSeeConcertClick() {
  gtmCdpAction('CV07 - See concert clicked')
}

const processedEvents = computed(() =>
  props.additionalEvents.map((item, index) => ({
    ...item,
    index,
    isExpired: dateInPast(item.eventEndDate || item.eventDate, 'now'),
    statusLabel: setStatusLabel(item.concertStatus, item.saleStatus),
  })),
)
</script>

<style scoped lang="scss"></style>
